import React, { useState, useContext } from 'react';
import Box from '@material-ui/core/Box';
import Stack from '@material-ui/core/Stack';
import Product from './components/Product/index';
import Snackbar from '@material-ui/core/Snackbar';
import AppContext, {
	Product as ProductType,
} from '../../shared/contexts/AppContext';
import MuiAlert, { AlertProps } from '@material-ui/core/Alert';
import { DispatchActions } from '../../shared/enums/DispatchActions';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
	props,
	ref
) {
	return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

const Products = () => {
	const appContext = useContext(AppContext);
	const { cart, products } = appContext.state;
	const [openCartAlert, setOpenCartAlert] = useState({
		open: false,
		productName: '',
	});

	const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
		if (reason === 'clickaway') {
			return;
		}

		setOpenCartAlert((prev) => ({
			...prev,
			open: false,
		}));
	};

	const addProductToCart = (productId: number) => {
		// Get product
		const product = products.find((prd: ProductType) => prd.id === productId);

		// Check if product is in cart
		const productIsInCart = cart.includes(product);

		// If product is in cart, only increase quantity - don't add product to array
		if (productIsInCart) {
			product.quantity++;
		} else {
			// Add product to array
			appContext.dispatch({
				type: DispatchActions.ADD_TO_CART,
				payload: product,
			});
		}

		// Update total amount
		appContext.dispatch({
			type: DispatchActions.UPDATE_TOTAL_AMOUNT,
		});

		setOpenCartAlert({
			open: true,
			productName: product.itemName,
		});
	};

	return (
		<>
			<Snackbar
				open={openCartAlert.open}
				autoHideDuration={3000}
				onClose={handleClose}
			>
				<Alert onClose={handleClose} severity='success' sx={{ width: '100%' }}>
					{openCartAlert.productName} was successfully added to your cart.
				</Alert>
			</Snackbar>
			<Box>
				<Stack
					direction={{ xs: 'column', sm: 'row' }}
					justifyContent='space-between'
					alignItems='center'
					spacing={2}
				>
					{products.map((product: ProductType) => {
						return (
							<Product
								key={product.id}
								product={product}
								addProductToCart={addProductToCart}
							/>
						);
					})}
				</Stack>
			</Box>
		</>
	);
};

export default Products;
